import { FC } from "react";
import { useTranslation } from "react-i18next";
import SDoc from "@/components/SDoc";
import ProductList from "./components/ProductList";
import CustomTabPane, { TabProps } from "@/components/TabPane";
import { Product } from "@/types/product";
import { CommonListParams } from "@/types/common";
import { productList } from "@/apis/product";
import ProductStoreReqList from "./components/ProductStoreReqList";

type CustomerTabType = 'doc' | 'img' | 'store';

const ProductHome: FC = () => {
  const { t } = useTranslation();
  const TAB_LIST_KEY = "list"
  const TAB_DOC_KEY = "doc"
  const TAB_IMG_KEY = "img"
  const TAB_STORE_KEY = "store"

  const keyObj: (info: Product) => { [key in CustomerTabType]: TabProps } = (info) => ({
    doc: {
      key: TAB_DOC_KEY,
      label: (info.code) + ' ' + t('product.folder'),
      children: <SDoc docId={info.docId} />
    },
    img: {
      key: TAB_IMG_KEY,
      label: (info.code) + ' ' + t('product.gallery'),
      children: <SDoc docId={info.picDocId} accept="image/*" />
    },
    store: {
      key: TAB_STORE_KEY,
      label: (info.code) + ' ' + t('product.storeType'),
      children: <ProductStoreReqList product={info} />
    }
  })

  return <CustomTabPane<Product> defaultKey={TAB_LIST_KEY} defaultTabs={[
    {
      key: TAB_LIST_KEY,
      label: t("layout.productList"),
      children: <ProductList />,
      closable: false,
    },
  ]} onOpens={(info) => keyObj(info)} />
}

export default ProductHome;